import React from 'react'
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function Footer() {
    const { t } = useTranslation();
    return (
        <footer>
            <div className="knsl-footer">
                <div className="container knsl-p-100-100">
                <div className="row">
                    <div className="col-md-6 col-lg-4">
                        <img className="knsl-footer-logo" src="assets/img/logo-w.svg" alt="Kinsley" />
                    <div className="knsl-footer-about">{t('main.firstDescription')}</div>
                    <div className="knsl-footer-social"> 
                        <a href="https://www.facebook.com/thewestheaven" target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a>
                        <a href="https://www.facebook.com/thewestheaven" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
                        <a href="https://www.facebook.com/thewestheaven" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
                        <a href="https://www.facebook.com/thewestheaven" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
                        <a href="https://www.facebook.com/thewestheaven" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                    </div>
                    <div className="col-md-6 col-lg-2">
                    <h4>{t('main.menu')}</h4>
                    <ul className="knsl-footer-menu">
                        <li><Link to={'/'}>{t('main.home')}</Link></li>
                        <li><Link to={'/about'}>{t('main.aboutUs')}</Link></li>
                        <li><Link to={'/rooms'}>{t('main.rooms')}</Link></li>
                        <li><Link to={'/#services'}>{t('main.ourServices')}</Link></li>
                        <li><Link to={'/contact'}>{t('main.contactInfo')}</Link></li>
                    </ul>
                    </div>
                    <div className="col-md-6 col-lg-3">
                    <h4>{t('main.usefulLinks')}</h4>
                    <ul className="knsl-footer-menu">
                        <li><Link to={'/restaurant'}>{t('main.restaurant')}</Link></li>
                        <li><Link to={'/blog?filter=news'}>{t('main.blog')}</Link></li>
                        <li><Link to={'/blog?filter=covid'}>{t('main.infoCovid')}</Link></li>
                        <li><Link to={'/gallery'}>{t('main.gallery')}</Link></li>
                        <li><Link to={'/faq'}>{t('main.faq')}</Link></li>
                    </ul>
                    </div>
                    <div className="col-md-6 col-lg-3">
                    <h4>{t('main.gallery')}</h4>
                    <div className="footer-insta">
                        <Link to="/gallery"><img src="assets/img/about/1.jpg" alt="The West Heaven Hotel"/></Link>
                        <Link to="/gallery"><img src="assets/img/about/2.jpg" alt="The West Heaven Hotel"/></Link>
                        <Link to="/gallery"><img src="assets/img/about/3.jpg" alt="The West Heaven Hotel"/></Link>
                        <Link to="/gallery"><img src="assets/img/about/4.jpg" alt="The West Heaven Hotel"/></Link>
                        <Link to="/gallery"><img src="assets/img/about/5.jpg" alt="The West Heaven Hotel"/></Link>
                        <Link to="/gallery"><img src="assets/img/about/6.jpg" alt="The West Heaven Hotel"/></Link>
                    </div>
                    </div>
                </div>
                </div>
                <div className="knsl-copyright">
                <div className="container">
                    <div className="copy-text">
                    <div>&copy; The West heaven Hotel 2021. {t('main.allRightReserved')}.</div>
                    </div>
                    <div className="copy-menu">
                    <div>{t('main.designWith')} 🤍 {t('main.by')} <a href="https://manuel-njiakim.com" target='_blank'  rel="noreferrer">Manuel Njiakim</a></div>
                    </div>
                </div>
                </div>
            </div>
            </footer>
    );
}

export default Footer